export const GET_EXPERIMENTS_DATA = "getExperimentsData"

export default {
  [GET_EXPERIMENTS_DATA]: (state: Experiments): Map<string, any> => state.experimentsData
}
